import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1755b911"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "option" }
const _hoisted_2 = {
  class: "option-label",
  "data-testid-label-slot": ""
}
const _hoisted_3 = { class: "is-flex is-justify-content-space-between is-align-items-center" }
const _hoisted_4 = { "data-testid-value-slot": "" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tab_index = _resolveDirective("tab-index")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "label", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "btn",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)), ["stop"])),
        "data-testid-button": "",
        "aria-label": _ctx.$t('search.filters.remove')
      }, _hoisted_7, 8, _hoisted_5)), [
        [_directive_tab_index, !_ctx.hidden]
      ])
    ])
  ]))
}